export default "__VITE_ASSET__5670e5cd__"